import Slider from "@kamae-apps/shared/old/Component/Input/Slider"
import React, { FC } from "react"
import { ElearningAdmin } from "../../../../Types/ELearning"
import { CategoryKey } from "./ElearningCategory"

type ElearningsListProps = {
  elearnings: ElearningAdmin[]
  categoryKey: CategoryKey
  check: boolean[]
  setCheck: (value: boolean[]) => void
  monthDelta: number[]
  setMonthDelta: (value: number[]) => void
  referenceDate: Date
}

const computeReleaseDate = (referenceDate: Date, delta: number): Date => {
  const d = new Date(referenceDate)
  d.setMonth(d.getMonth() + delta, 1)
  return d
}

export const ElearningsList: FC<ElearningsListProps> = ({
  elearnings,
  categoryKey,
  check,
  setCheck,
  monthDelta,
  setMonthDelta,
  referenceDate,
}) => {
  return (
    <>
      {elearnings.map((elearning, i) => {
        if (elearning.category !== categoryKey) {
          return (
            <div
              key={i}
              className={"hidden"}
            ></div>
          )
        }
        const comment = elearning.comment == null ? "" : `(${elearning.comment})`
        const releaseDate = computeReleaseDate(referenceDate, monthDelta[i] ?? elearning.monthDelta)
        return (
          <div
            className={
              "flex w-2/3 shrink-0 flex-col justify-center gap-3 rounded-xl bg-white p-3 drop-shadow-md hover:drop-shadow-lg"
            }
            key={i}
          >
            <div className={"flex items-center justify-start gap-3"}>
              <Slider
                value={elearning.id}
                checked={check[i] ?? false}
                id={"elearning" + elearning.id}
                onChange={() => {
                  setCheck(check.map((v, index) => (i === index ? !v : v)))
                }}
                className={"m-1"}
              />
              <label
                htmlFor={"elearning" + elearning.id}
                className={"w-full"}
              >
                <p className={"mr-2"}>
                  {elearning.title}
                  <wbr />
                  <span className={"pl-2 text-sm text-gray-400"}>{comment}</span>
                </p>
              </label>
            </div>
            <div className={"flex items-center gap-2"}>
              <span className={"text-sm text-gray-500"}>M+</span>
              <input
                type="number"
                min={0}
                value={monthDelta[i] ?? elearning.monthDelta}
                onChange={e => setMonthDelta(monthDelta.map((v, idx) => (idx === i ? Number(e.target.value) : v)))}
                className={"w-16 rounded border border-gray-300 px-2 py-1 text-sm"}
              />
              <span className={"text-sm text-gray-400"}>→ {releaseDate.toLocaleDateString("fr-FR")}</span>
            </div>
          </div>
        )
      })}
    </>
  )
}
